<template>
  <v-container fill-height fill-width grid-list-md>
    <div class="container">
      <AppBar class="details">
        <template v-slot:title>
          Administradores
        </template>
      </AppBar>

      <v-tabs v-model="tabs" fixed-tabs centered background-color="grayappbar">
        <v-tab v-for="item in tabItems" :key="item">{{ item }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabs">
        <!--Administradores-->
        <v-tab-item>
          <div class="wrapper-new-admin">
            <v-text-field
              label="Entre com o username"
              v-model="txtUsername"
              outlined
            ></v-text-field>
            <v-btn color="primary" @click="grantAdminRole()"
              >Adicionar como administrador
            </v-btn>
          </div>
          <UsersList @delete-action="removeAdminRole" :items="adminUsers" />
        </v-tab-item>

        <!--Whitelist de gavetas-->
        <v-tab-item>
          <div class="wrapper-whitelist">
            <div class="section-title">
              Cadastrar uma nova gaveta
            </div>
            <div class="folder-input">
              <v-select
                :items="adminPlaces"
                item-text="place_name"
                label="Praça"
                outlined
                dense
                color="primary"
                v-model="place"
              ></v-select>
              <v-text-field
                label="Gaveta (ex: PAUTA.RJ.REDE.SEG)"
                v-model="newFolder"
                dense
                outlined
                clearable
              ></v-text-field>
              <v-btn
                color="primary"
                height="40"
                class="create-button"
                @click="handleCreateFolder"
                >Criar</v-btn
              >
            </div>
            <div class="section-title">
              Gavetas marcadas serão indexadas na base de dados do NewsHub
            </div>
            <v-treeview
              v-model="selectedFolders"
              :items="adminFolders"
              label="Gavetas"
              :open.sync="openNodes"
              selected-color="primary"
              selectable
              dense
              open-on-click
              hoverable
              transition
            />
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="handleApply" class="apply-button"
              >Aplicar</v-btn
            >
          </div>
        </v-tab-item>

        <!--Gavetas de espelho-->
        <v-tab-item>
          <Mirrors
            :adminMirrorFolders="adminMirrorFolders"
            :adminPlaces="adminPlaces"
          />
        </v-tab-item>

        <v-tab-item>
          <MirrorCategoryComponent />
        </v-tab-item>

        <v-tab-item>
          <FormHiddenFieldsComponent />
        </v-tab-item>
        <v-tab-item>
          <Variables :adminVariables="adminVariables" />
        </v-tab-item>
      </v-tabs-items>
    </div>

    <!-- modal deletion -->
    <v-dialog v-model="deleteDialog" max-width="480">
      <v-card>
        <v-row>
          <v-icon color="gray">error_outline</v-icon>
        </v-row>
        <v-card-title class="headline">Remover</v-card-title>
        <v-card-text>
          Tem certeza que deseja remover a permissão de administrador para o
          usuário <strong>{{ this.selectedUser.name }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-btn large outlined text @click="deleteDialog = false"
            >Cancelar
          </v-btn>
          <v-btn color="primary" large outlined text @click="confirmDeletion()"
            >Sim, desejo remover</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- modal deletion:end -->

    <!-- error snackbar -->
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :multi-line="true"
      :color="snackbarType"
      bottom
      right
    >
      {{ snackbarMessage }}
      <v-btn text @click="snackbar = false">Entendi</v-btn>
    </v-snackbar>
    <!-- end error snackbar -->

    <LoadingOverlay
      z-index="5"
      :enabled="
        loadingAdminUsers ||
          loadingFolders ||
          loadingMirrorFolders ||
          loadingAdminUsers ||
          loadingAdminMirrorCategories ||
          loadingAdminHiddenFields
      "
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import AppBar from '@/components/shared/AppBar.vue';
import UsersList from '@/components/admin/UsersList.vue';
import Mirrors from '@/components/admin/Mirrors.vue';
import { getInitiallyOpenNodes } from '@/utils/treeView';
import Variables from '@/components/admin/Variables';
import LoadingOverlay from '../components/shared/LoadingOverlay.vue';
import MirrorCategoryComponent from '@/components/admin/MirrorCategoryComponent/index.vue';
import FormHiddenFieldsComponent from '@/components/admin/FormHiddenFieldsComponent.vue';

export default {
  name: 'admin',
  components: {
    Variables,
    AppBar,
    UsersList,
    Mirrors,
    LoadingOverlay,
    MirrorCategoryComponent,
    FormHiddenFieldsComponent,
  },
  data() {
    return {
      snackbarTimeout: 6000,
      drawer: false,
      deleteDialog: false,
      selectedUser: {
        id: null,
        name: null,
      },
      txtUsername: null,
      tabs: 0,
      tabItems: [
        'Controle de Administradores',
        'Controle de Gavetas',
        'Controle de Espelhos',
        'Controle de Categorias de Espelho',
        'Controle de Colunas',
        'Variáveis de Sistema',
      ],
      place: null,
      newFolder: null,
      folderId: null,
      selectedFolders: [],
      openNodes: [],
      folderList: [],
    };
  },
  computed: {
    ...mapState({
      loadingAdminUsers: state => state.admin.loadingAdminUsers,
      loadingFolders: state => state.admin.loadingFolders,
      loadingMirrorFolders: state => state.admin.loadingMirrorFolders,
      loadingAdminVariables: state => state.admin.loadingAdminVariables,
      adminUsers: state => state.admin.adminUsers,
      adminFolders: state => state.admin.adminFolders,
      adminPlaces: state => state.admin.adminPlaces,
      adminVariables: state => state.admin.adminVariables,
      snackbarMessage: state => state.snackbar.snackbarMessage,
      snackbarTrigger: state => state.snackbar.snackbarTrigger,
      snackbarType: state => state.snackbar.snackbarType,
      adminMirrorFolders: state => state.admin.adminMirrorFolders,
      adminMirrorCategories: state => state.admin.adminMirrorCategories,
      loadingAdminMirrorCategories: state =>
        state.admin.loadingAdminMirrorCategories,
      loadingAdminHiddenFields: state => state.admin.loadingAdminHiddenFields,
    }),
    snackbar: {
      get() {
        return this.snackbarTrigger;
      },
      set(value) {
        this.$store.dispatch('snackbar/updateTrigger', value);
      },
    },
  },
  watch: {
    adminFolders() {
      if (this.adminFolders && this.adminFolders.length > 0) {
        this.folderList = [];
        this.getInitiallySelectedFolders(this.adminFolders);
        this.openNodes = getInitiallyOpenNodes(this.selectedFolders);
      }
    },
  },
  created() {
    this.$store.dispatch('admin/getAdminUsers');
    this.$store.dispatch('admin/getPlaces');
    this.$store.dispatch('admin/getFolders');
    this.$store.dispatch('admin/getMirrorFolders');
    this.$store.dispatch('admin/getAdminVariables');
    this.$store.dispatch('admin/getMirrorCategories');
    this.$store.dispatch('admin/getHiddenFields');
  },
  methods: {
    checkInputAndDisplayError(input) {
      if (!input) {
        this.$store.dispatch('snackbar/showSnackbarWithMessage', {
          message: 'Entre com o nome de usuário.',
          type: 'error',
        });
        return false;
      }
      if (input.length < 5) {
        this.$store.dispatch('snackbar/showSnackbarWithMessage', {
          message: 'Nome de usuário inválido.',
          type: 'error',
        });
        return false;
      }
      if (this.adminUsers.find(user => user.name === input)) {
        this.$store.dispatch('snackbar/showSnackbarWithMessage', {
          message: 'Usuário já cadastrado.',
          type: 'error',
        });
        return false;
      }
      return true;
    },
    grantAdminRole() {
      const treatedInput = this.txtUsername
        ? this.txtUsername.trim().toLowerCase()
        : null;

      if (this.checkInputAndDisplayError(treatedInput)) {
        this.$store.dispatch('admin/grantAdminRole', treatedInput);
        this.txtUsername = '';
      }
    },
    removeAdminRole({ id, name }) {
      this.deleteDialog = true;
      this.selectedUser = { id, name };
    },
    clearSelectedUser() {
      this.selectedUser = { id: null, name: null };
    },
    confirmDeletion() {
      this.$store.dispatch('admin/removeAdminRole', this.selectedUser);
      this.deleteDialog = false;
      this.clearSelectedUser();
    },
    handleApply() {
      this.updateFolderList();
      this.$store.dispatch('admin/updateFolder', this.folderList);
    },
    handleCreateFolder() {
      if (!this.place || !this.newFolder) {
        this.$store.dispatch('snackbar/showSnackbarWithMessage', {
          message: 'Por favor selecione uma Praça e preencha uma Gaveta',
          type: 'error',
        });
      } else {
        this.$store.dispatch('admin/createFolder', {
          place: this.place,
          path: this.newFolder.toUpperCase(),
        });
      }
    },
    getInitiallySelectedFolders(nodeList) {
      nodeList.forEach(currentNode => {
        if (currentNode && currentNode.children) {
          this.getInitiallySelectedFolders(currentNode.children);
        } else {
          if (currentNode.to_ingest) {
            this.selectedFolders.push(currentNode.id);
          }
          this.folderList.push({
            folder_id: currentNode.folder_id,
            to_ingest: currentNode.to_ingest,
            path: currentNode.id,
          });
        }
      });
    },
    updateFolderList() {
      this.folderList.forEach(folder => {
        folder.to_ingest = this.selectedFolders.indexOf(folder.path) >= 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme.scss';
@import '@/assets/scss/theme-v2.scss';

.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  width: 100%;
  max-width: 100%;
  height: 100vh;
  padding: 44px 0 48px 0 !important;

  .v-tabs-items {
    margin-top: 16px;

    .wrapper-new-admin {
      display: flex;
      flex-direction: column;
      width: 600px;
      margin: 0 auto;
    }
    .wrapper-whitelist {
      width: 600px;
      height: calc(100vh - 180px);

      .folder-input {
        display: flex;
        height: 36px;
        margin-bottom: 24px;
        .v-select {
          height: 36px;
          flex: 0 0 88px !important;
          margin: 0 4px 0 0;
        }
        .v-text-field {
          margin: 0 4px 0 0;
        }
        .create-button {
          flex: 0 0 64px !important;
        }
      }
      .section-title {
        margin-bottom: 8px;
        color: $color-gray-dark;
        font-size: 1.1em;
      }

      .v-treeview {
        background-color: $color-gray-lighter;
        border-radius: 5px;
        overflow: auto;
        height: calc(100vh - 300px);
      }

      .apply-button {
        position: absolute;
        bottom: 8px;
        right: 12px;
      }
    }
    // Medium Screens
    @media screen and (max-width: 1200px) {
      padding-bottom: 0;
      height: auto;
      overflow-y: auto;
    }

    @media screen and (max-width: 1200px) {
    }

    // Small Screens
    @media screen and (max-width: 700px) {
      padding: 48px 8px 32px 8px;
      overflow-y: auto;
      min-height: 90vh;
    }
  }
}

.v-dialog {
  .v-card {
    padding: 24px;
    overflow: hidden;

    @include for-size(phone-only) {
      padding: 16px 8px;
    }

    // Icon
    .row {
      justify-content: center;

      i {
        font-size: 4em;
        opacity: 0.24;
      }
    }

    // Title
    .v-card__title {
      position: relative;
      text-align: center;
      justify-content: center;
      font-style: italic;
      color: $color-gray-dark;
      margin: -8px 0 24px 0;

      @include for-size(phone-only) {
        margin: -8px 0 8px 0;
      }
    }

    // Text
    .v-card__text {
      font-size: 1em;
      color: $color-gray-main;
      text-align: center;

      @include for-size(phone-only) {
        font-size: 0.88em;
        line-height: 1.2em;
      }

      span {
        font-weight: 700;
        color: $color-gray-dark;
      }
    }

    ::v-deep .v-card__actions {
      justify-content: flex-end;

      @include for-size(phone-only) {
        display: flex;
        flex-wrap: wrap;

        .v-btn {
          flex: 0 0 100%;
          margin: 0 0 8px 0;
        }
      }
    }
  }
}
</style>
